export default function Footer() {
  return (
    <footer className="relative z-10 border-t mt-8">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 py-8 space-y-3">
        <div className="flex items-center gap-2">
          <img src="/logo64.png" alt="GMScan logo" className="h-5 w-5 rounded" />
          <span className="text-sm font-semibold" style={{ fontFamily: "Outfit" }}>GMScan</span>
          <span className="text-xs text-muted-foreground">— Explore Robinhood Chain clearly and confidently.</span>
          <a
            data-testid="footer-x-link"
            href="https://x.com/gm_"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GMScan on X"
            className="ml-auto flex items-center gap-1.5 text-xs text-muted-foreground hover:text-primary transition-colors duration-200"
          >
            <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
            </svg>
            @gm_
          </a>
        </div>
        <p data-testid="footer-disclaimer" className="text-xs text-muted-foreground max-w-3xl leading-relaxed">
          GMScan is an independent blockchain explorer for Robinhood Chain. It is not operated, endorsed, or
          affiliated with Robinhood Markets, Inc. Blockchain stock tokens shown here may differ from owning
          traditional shares through a broker. Data is sourced from public Robinhood Chain RPC and Blockscout
          indexers. Nothing on this site is financial advice.
        </p>
      </div>
    </footer>
  );
}
